import React from 'react';
import {sortToPersian} from 'utilities/helper/sortToPersian';
interface FiltersProps {
  title: string;
  isSortOpen: boolean;
  isFilterOpens: boolean;
  setIsSortOpen: (isSortOpen: boolean) => void;
  setisFilterOpens: (isFilterOpens: boolean) => void;
  sortFilter: string;
}
const Filters = ({
  title,
  isFilterOpens,
  isSortOpen,
  setIsSortOpen,
  setisFilterOpens,
  sortFilter,
}: FiltersProps) => {
  return (
    <div className="flex justify-between items-center text-normal text-[18px]">
      <h4 className="text-gray-6">{title}</h4>
      <div className="flex justify-between gap-2">
        <button
          onClick={() => setisFilterOpens(!isFilterOpens)}
          className="flex justify-between  items-center text-primary gap-2 border border-primary rounded-lg px-[12px] py-[9px]"
        >
          <span className="font-medium text-[14px]">فیلتر کردن</span>
          <span className="icon-Filter " />
        </button>
        <button
          onClick={() => setIsSortOpen(!isSortOpen)}
          className="flex justify-between items-center text-primary gap-2 border border-primary rounded-lg px-[12px] py-[9px]"
        >
          <span className="font-medium text-[14px]">
            {sortToPersian[sortFilter]}
          </span>
          <span className="icon-ordering " />
        </button>
      </div>
    </div>
  );
};

export default Filters;
